import React from "react";
import "./index.scss";
import { FormGroup } from "reactstrap";

type QuestionInputProps = {
  style?: any;
  labelText: string;
  attribute: string;
  data: any;
  callback: (attribute: string, value: any) => void;
  options: Array<any>;
};

const CustomQuestionInput = ({
  style,
  labelText,
  callback,
  data,
  options,
  attribute,
}: QuestionInputProps) => {
  const value = data?.[attribute];
  return (
    <div className="custom-attribute__text-input" style={style}>
      <span className="custom-attribute__text-input-label">{labelText}</span>
      <FormGroup className="radio-group">
        {options.map((el) => (
          <div
            className="radio-item normal-button"
            key={el.value}
            onClick={() => {
              callback(attribute, el);
            }}
          >
            <input readOnly type="radio" checked={value === el.value} />
            <span className="radio-label">{el.label}</span>
          </div>
        ))}
      </FormGroup>
    </div>
  );
};

export default CustomQuestionInput;
